import axios from '@/libs/api.request'
import config from '@/config'

const networkBaseUrl = config.baseNetworkUrl + '/api/v1/'

export const getNetworkServerGroup = () => {
  return axios.request({
    url: networkBaseUrl + 'server_group/',
    method: 'get'
  })
}

export const changeNetworkServerGroup = (data, id) => {
  let url = networkBaseUrl + 'server_group/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const deleteNetworkServerGroup = (id) => {
  return axios.request({
    url: networkBaseUrl + 'server_group/' + id + '/',
    method: 'delete'
  })
}

export const getNetworkServer = (params) => {
  return axios.request({
    url: networkBaseUrl + 'server/',
    params: params,
    method: 'get'
  })
}

export const getNetworkAllServer = (params) => {
  return axios.request({
    url: networkBaseUrl + 'all_server_list/',
    params: params,
    method: 'get'
  })
}

export const detailNetworkServer = (id) => {
  return axios.request({
    url: networkBaseUrl + 'server/' + id + '/',
    method: 'get'
  })
}

export const changeNetworkServer = (data, id) => {
  let url = networkBaseUrl + 'server/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const deleteNetworkServer = (id) => {
  return axios.request({
    url: networkBaseUrl + 'server/' + id + '/',
    method: 'delete'
  })
}

export const getNetworkCertificate = (params) => {
  return axios.request({
    url: networkBaseUrl + 'certificate/',
    params: params,
    method: 'get'
  })
}

export const getNetworkAllCertificate = () => {
  return axios.request({
    url: networkBaseUrl + 'all_certificate_list/',
    method: 'get'
  })
}

export const detailNetworkCertificate = (id) => {
  return axios.request({
    url: networkBaseUrl + 'certificate/' + id + '/',
    method: 'get'
  })
}

export const changeNetworkCertificate = (data, id) => {
  let url = networkBaseUrl + 'certificate/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const deleteNetworkCertificate = (id) => {
  return axios.request({
    url: networkBaseUrl + 'certificate/' + id + '/',
    method: 'delete'
  })
}

export const getNetworkProtocol = (params) => {
  return axios.request({
    url: networkBaseUrl + 'protocol/',
    params: params,
    method: 'get'
  })
}

export const getNetworkAllProtocol = () => {
  return axios.request({
    url: networkBaseUrl + 'all_protocol_list/',
    method: 'get'
  })
}

export const detailNetworkProtocol = (id) => {
  return axios.request({
    url: networkBaseUrl + 'protocol/' + id + '/',
    method: 'get'
  })
}

export const changeNetworkProtocol = (data, id) => {
  let url = networkBaseUrl + 'protocol/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const deleteNetworkProtocol = (id) => {
  return axios.request({
    url: networkBaseUrl + 'protocol/' + id + '/',
    method: 'delete'
  })
}

export const UnlockCertificateKey = (params) => {
  return axios.request({
    url: networkBaseUrl + 'unlock_key/',
    params: params,
    method: 'get'
  })
}

export const getUnlockLogs = (params) => {
  return axios.request({
    url: networkBaseUrl + 'unlock_logs_list/',
    params: params,
    method: 'get'
  })
}

// 扫描主机或者其他设备
export const scanServer = (data) => {
  return axios.request({
    url: networkBaseUrl + 'scan_info/',
    data: data,
    method: 'post'
  })
}

export const detailConfigExecLogs = (id) => {
  return axios.request({
    url: networkBaseUrl + 'config_exec_logs_list/' + id + '/',
    method: 'get'
  })
}

export const getConfigExecLogs = (params) => {
  return axios.request({
    url: networkBaseUrl + 'config_exec_logs_list/',
    params: params,
    method: 'get'
  })
}

export const getConfigVersionHistory = (params) => {
  return axios.request({
    url: networkBaseUrl + 'config_history_list/',
    params: params,
    method: 'get'
  })
}

export const getNetworktAllConfig = (params) => {
  return axios.request({
    url: networkBaseUrl + 'config_history_all/',
    params: params,
    method: 'get'
  })
}

export const detailConfigVersionHistory = (id) => {
  return axios.request({
    url: networkBaseUrl + 'config_history_detail/' + id + '/',
    method: 'get'
  })
}

// 对比配置版本信息
export const compareConfig = (data) => {
  return axios.request({
    url: networkBaseUrl + 'compare_info/',
    data: data,
    method: 'post'
  })
}

// 扫描主机或者其他设备
export const rollbackServer = (data) => {
  return axios.request({
    url: networkBaseUrl + 'rollback_info/',
    data: data,
    method: 'post'
  })
}

// 同步交换机数据
export const syncServer = (data) => {
  return axios.request({
    url: networkBaseUrl + 'sync_info/',
    data: data,
    method: 'post'
  })
}

// 配置策略
export const getConfigStrategyList = (params) => {
  return axios.request({
    url: networkBaseUrl + 'config_strategy/',
    params: params,
    method: 'get'
  })
}

export const detailConfigStrategy = (id) => {
  return axios.request({
    url: networkBaseUrl + 'config_strategy/' + id + '/',
    method: 'get'
  })
}

export const editConfigStrategy = (data, id) => {
  let url = networkBaseUrl + 'config_strategy/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const deleteConfigStrategy = (id) => {
  return axios.request({
    url: networkBaseUrl + 'config_strategy/' + id + '/',
    method: 'delete'
  })
}

// 开始配置校验
export const configStartExamine = (data) => {
  return axios.request({
    url: networkBaseUrl + 'start_examine/',
    data: data,
    method: 'post'
  })
}

// 配置校验历史
export const getConfigExamineHistoryList = (params) => {
  return axios.request({
    url: networkBaseUrl + 'config_examine_history/',
    params: params,
    method: 'get'
  })
}

export const detailConfigExamineHistoryList = (id) => {
  return axios.request({
    url: networkBaseUrl + 'config_examine_history/' + id + '/',
    method: 'get'
  })
}

export const ConfigPeriodicExamine = (data) => {
  return axios.request({
    url: networkBaseUrl + 'config_periodic_examine/',
    data: data,
    method: 'post'
  })
}

// 删除配置备份版本
export const deleteConfigVersion = (id) => {
  return axios.request({
    url: networkBaseUrl + 'config_history/' + id + '/',
    method: 'delete'
  })
}
